<template>
  <div class="cashflow-type-economy card-box">
    <div class="title">
      <span>{{ titles.cardTitle }}</span>
    </div>

    <expense-progress :up-to-now-label="titles.expenseProgress.actualsLabel"
                      :up-to-now-amount="economyExpenses.upToNowAmount"
                      :show-warning-if-exceeding-budget="false"/>

    <predicted-category-sections :actuals-title="titles.categorySections.actualsTitle"
                                 :categories="economyExpenses.categories"
                                 :initially-expanded="false"
                                 :show-recommended-title="false"
                                 :title="titles.categorySections.mainTitle"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="{ transactions }">
        <div class="transaction-list">
          <transaction-row class="transaction-details"
                                     v-for="transaction in transactions"
                                     :transaction="transaction"
                                     :can-edit-category="true"
                                     :category-name="categoryName"
                                     v-bind:key="transaction.transactionId">

          </transaction-row>
        </div>
      </template>
    </predicted-category-sections>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';
import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';
import PredictedTransactionRow from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedTransacionRow.vue';
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import TransactionRow from '../../../generic-components/cashflow-types/cashflow-types-base/TransactionRow.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';


export default {
  name: 'CashflowTypeEconomy',
  mixins: [CashflowAnalytics],
  components: {
    TransactionRow,
    ExpenseProgress,
    PredictedTransactionRow,
    PredictedCategorySections,
  },
  computed: {
    ...mapState('cashflowView', ['cashflowUITree']),
    CASHFLOW_TYPE() {
      return cashflowViewConsts.cashflowTypes.economy;
    },
    economyExpenses() {
      return this.cashflowUITree[this.CASHFLOW_TYPE];
    },
    categoryName() {
      return cashflowViewConsts.CATEGORY_NAMES.RECURRING_ECONOMY;
    },
    titles() {
      return {
        expenseProgress: {
          actualsLabel: 'כמה יצא?',
        },
        categorySections: {
          actualsTitle: 'יצא',
          mainTitle: 'פירוט שבועי של הוצאות סופר',
        },
        cardTitle: 'הוצאות סופר',
      };
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .past-cashflow-view-container {
    .cashflow-type-economy {
      @include cashflow-card;

      .title {
        @include cashflow-card-title;
      }

      .cashflow-type-color {
        color: $riseup_light_blue;
      }

      .cashflow-type-background-color {
        background-color: $riseup_light_blue;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/past-editable-month/components/types/CashflowTypeEconomy.vue